import { Component, OnInit, Input, Output, EventEmitter,
   ViewChild, AfterViewInit, AfterViewChecked, ElementRef,
    AfterContentInit, AfterContentChecked, ViewContainerRef,
    ChangeDetectionStrategy, ChangeDetectorRef, OnDestroy
} from '@angular/core';
import { Action } from 'app/clmtlk/shared/model/action';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { ClmtlkService } from 'app/clmtlk/shared/service/clmtlk.service';
import { FileUploadComponent } from './file-upload/file-upload.component';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import {SessionStorage} from 'ngx-webstorage';
import { Conversation, ConversationContact, Conversations, ThreadMessage, Message } from 'app/clmtlk/shared/model/conversationContacts';
import { ClmtlkSessionService } from 'app/clmtlk/shared/service/clmtlk-session.service';
import { BlockUIService } from 'ng-block-ui';
import { MessagePayload } from 'app/clmtlk/shared/model/serverObjects';



@Component({
  selector: 'clmtlk-message-form',
  templateUrl: './message-form.component.html',
  // changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./message-form.component.scss']
})
export class MessageFormComponent implements OnInit, AfterContentChecked, OnDestroy {

  @Input()  action: Action;
  @Output() actionChange: EventEmitter<Action> = new EventEmitter();
  ACTION = Action;
  @Input() conversation: Conversation;
  @Input() originalConversation: Conversation;
  @ViewChild('clmFileUpload') fileUploadComponent: FileUploadComponent;
  @ViewChild('focusToLabel') focusElement: ElementRef;
  @ViewChild('exitConfirmationContent') exitConfirmationContent: any;
  mouseoverSubmit = false;
  files: any[];
  frmConversationContact: ConversationContact;
  @SessionStorage('newConversationContacts') private newConversationContacts;

  selectedToConvContacts: ConversationContact[]= [];
  selectedCcConvContacts: ConversationContact[]= [];
  messageContent: string;
  subject: string;
  piiIndicator = false;

  piiIndicator1 = 'false';

  yesno = [
    {label:'Yes', value:'true' },
    {label:'No', value:'false'}]

  constructor(private modalService: NgbModal,
              private clmtlkService: ClmtlkService,
              public clmtlkSessionService: ClmtlkSessionService,
              private cdr: ChangeDetectorRef,
              private router: Router,
              private blockUIService: BlockUIService,
              private toastrService: ToastrService ) {
      }

  ngOnInit() {
    

    console.info("this.conversation.newConversationContacts",this.conversation.newConversationContacts);

    if ( this.conversation && this.conversation.newConversationContacts) {
      this.conversation.newConversationContacts.conversationContact.forEach(conversationContact => {
        // <!-- REMOVE SMS OPTION -->  remove this from to and cc -> && conversationContact.contacts.contact[0].CTC_TYP_CD === 'email'
        if (conversationContact.CTC_ADDR_TYP_CD.trim() === 'to'
                && !this.isConversationContactOptedOut(conversationContact)) {
          this.selectedToConvContacts.push(conversationContact);
        }else if (conversationContact.CTC_ADDR_TYP_CD.trim() === 'cc'
                && !this.isConversationContactOptedOut(conversationContact)) {
          this.selectedCcConvContacts.push(conversationContact);
        }else if(conversationContact.CTC_ADDR_TYP_CD === 'frm') {
              this.frmConversationContact = conversationContact;
          }
      });
    }

    this.piiIndicator = (this.clmtlkSessionService.isConversationAlreadySecured === true
                              && this.action !== this.ACTION.NEWCONVERSATION);

  }


  ngAfterContentChecked(): void {
    if (this.focusElement) {
      if (this.focusElement.nativeElement && !this.focusElement.nativeElement.hasscrolled) {
        this.focusElement.nativeElement.scrollIntoView();
        this.focusElement.nativeElement.hasscrolled = true;
      }
    }
  }

  //SP 2018-08-23 Added to check if a conversation contact is opted in
  //on the autocomplete list. Mainly for SMS contacts
  isConversationContactOptedOut(inputConversationContact : ConversationContact){
    let isOptedOut = false;

    if( inputConversationContact.contacts.contact[0].CTC_TYP_CD === 'sms'){
      //Find the contact in the autocomplete list to see if he is opted out
       isOptedOut =  this.clmtlkSessionService.streamContacts
          .some((convContact) => {
          return (convContact.contacts.contact[0].CTC_VAL_TXT === inputConversationContact.contacts.contact[0].CTC_VAL_TXT
              && convContact.contacts.contact[0].contactOptStatuses.contactOptStatus.CTC_OPT_STS_CD === 'U');
          });
    }

    return isOptedOut;
  }

  showPiiModalConditionally(messageForm,  piiAttachementModalContent) {

    if (this.files && this.files.length > 0 && this.piiIndicator !== true &&
            (this.clmtlkSessionService.isConversationAlreadySecured !== true || this.action === this.ACTION.NEWCONVERSATION)) {
      this.modalService.open(piiAttachementModalContent, { backdrop: 'static', keyboard: false }).result.then(
        (result) => {
          this.piiIndicator = true;
          this.saveMessage(messageForm);
        }, (reason) => {
          this.piiIndicator = false;
          this.saveMessage(messageForm);
        });
    }else {
      this.saveMessage(messageForm);
    }

  }

  openPiiInfoModal(piiInfoContent){
    this.modalService.open(piiInfoContent, { backdrop: 'static', keyboard: false }).result.then(
      (result) => {
      }, (reason) => {
      });
  }


  saveMessage(messageForm) {
    this.toastrService.clear();
    this.blockUIService.start('main', 'Posting a Message... please wait');

    // PreparePayload
    const payload = this.populateConversationPayload();
    this.clmtlkService.postConversation(payload).subscribe(
      result => {
        // if sucess, navigate to thread view page
        messageForm.resetForm();
        this.processMessageResult(result);
      },
      error => {
          this.blockUIService.stop('main');
          this.toastrService.error(`Message Delivery Failed - ${error}`, 'Unsuccess',
          { closeButton: true, positionClass: 'toast-top-full-width', tapToDismiss: false , timeOut: 0} );
      }
    );

  }

  cancelMessage() {
    if (this.action === Action.NEWCONVERSATION) {
        this.router.navigate(['/inbox']);
    }else {
         this.clmtlkSessionService.setConversationContext('EXISTING_THREAD_CONVERSATION'
        , this.originalConversation
        , Action.CANCEL_NEWCONVERSATION);
        const conv_id = this.originalConversation.CONV_ID;
        const thrd_id = this.originalConversation.conversationThreads.conversationThread[0].THRD_ID;
        this.router.navigate(['/convo', conv_id, 'thread', thrd_id]);
    }

  }

  processMessageResult(result) {
    const conversation: Conversation = <Conversation>result;
    const token = this.extractUserToken(conversation);
    if (token && token !== null ) {
      this.clmtlkSessionService.setAuthTokenAndPin(token, conversation.CONV_SEC_PIN_TXT);
    }

    if (this.action === this.ACTION.NEWCONVERSATION) {
      // Set Pin if New Conversation is created. If no pin, it will be set to Null.
      // setAuthTokenAndPin method will not set pin to null , if conversation.CONV_SEC_PIN_TXT is null
        this.clmtlkSessionService.setNewPin(conversation.CONV_SEC_PIN_TXT);
    }

    this.clmtlkSessionService.setConversationContext('EXISTING_THREAD_CONVERSATION', conversation, Action.VIEWMESSAGE);
    const conv_id = conversation.CONV_ID;
    const thrd_id = conversation.conversationThreads.conversationThread[0].THRD_ID;
    this.blockUIService.stop('main');
    this.router.navigate(['/convo', conv_id, 'thread', thrd_id]);
  }

  extractUserToken(conversation: Conversation): string {
    let token: string = null;
    const contactId = this.clmtlkSessionService.loggedInContact.CTC_ID;
    const message: Message = conversation
                                        .conversationThreads.conversationThread[0]
                                        .threads.thread[0]
                                        .threadMessages.threadMessage[0].messages.message[0];
    message.conversationContacts.conversationContact.forEach(conversationContact => {
        // tslint:disable-next-line:triple-equals
        if (conversationContact.CTC_ID == contactId) {
          token = conversationContact.OAUTH_TOKEN;
        }
    });
    return token;
  }

  populateConversationPayload(): MessagePayload {

    const threadMessageList: ThreadMessage[] = this.conversation.conversationThreads
                                .conversationThread[0].threads.thread[0]
                                .threadMessages.threadMessage;
    let message: Message;
    threadMessageList.forEach(threadMessage => {
      if ( !threadMessage.MSG_ID ||  threadMessage.MSG_ID === null) {
        message = threadMessage.messages.message[0];
      }
    });

    message.MSG_CNTNT_XML = `<![CDATA[${this.messageContent}]]>`;

    this.addConversationContacts(message);

    if (this.ACTION.NEWCONVERSATION === this.action) {
      this.conversation.CONV_SUBJ = this.subject;
    }

    this.conversation.newConversationContacts = null;
    const conversations: Conversations =  {
      conversation: [this.conversation]
    };

    const messagePayload: MessagePayload = <MessagePayload>{
      root: {conversations},
      attachments: this.files
    }

    return messagePayload;
  }

  addConversationContacts(message: Message) {

    const frmContact: ConversationContact =
    (this.clmtlkSessionService.impersonatedContact && this.clmtlkSessionService.impersonatedContact != null) ?
    this.clmtlkSessionService.impersonatedContact : this.frmConversationContact;

      message.conversationContacts = {
        conversationContact: [frmContact]
      };

    this.selectedToConvContacts.forEach(convContact => {
      convContact.CTC_ADDR_TYP_CD = 'to';
      message.conversationContacts.conversationContact.push(convContact);
      //console.info("selectedToConvContacts", message.conversationContacts.conversationContact)
    });

    this.selectedCcConvContacts.forEach(convContact => {
      convContact.CTC_ADDR_TYP_CD = 'cc';
      message.conversationContacts.conversationContact.push(convContact);
    });

    if (this.piiIndicator === true ||
      (this.clmtlkSessionService.isConversationAlreadySecured === true && this.action !== this.ACTION.NEWCONVERSATION)) {
      message.conversationContacts.conversationContact.forEach( conversationContact => {
        conversationContact.MSG_SEC_IND = 'Y';
      });
    }

  }

  canDeactivate() {

      if ((this.messageContent && this.messageContent !== '')
          || (this.selectedToConvContacts && this.selectedToConvContacts.length > 0)
          || (this.selectedCcConvContacts && this.selectedCcConvContacts.length > 0)) {
            return this.modalService.open(this.exitConfirmationContent, { backdrop: 'static', keyboard: false }).result.then(
              (result) => {
                  return true;
              }, (reason) => {
                  return false;
              });
      } else {
        return true;
      }
  }




  ngOnDestroy(): void {
    this.toastrService.clear();
  }

  fileAttachmentList(files) {
    this.files = files;
  }

}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/CLAIMS_PIPELINE/CLMTLK_UI_APP_PIPELINE/src/app/clmtlk/new-message/message-form/message-form.component.ts